import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchStyleOrderDocuments,
  type StyleOrderDocumentsListParams,
} from '@/api/my-styles';

function buildStyleOrderDocumentsQs(
  params: StyleOrderDocumentsListParams,
): string {
  const qs = new URLSearchParams({
    page: String(Math.max(1, params.page)),
    count: String(params.count),
  });
  if (params.name) qs.set('name', params.name);
  if (params.documentTypeId) qs.set('documentTypeId', params.documentTypeId);
  if (params.orderNumber) qs.set('orderNumber', params.orderNumber);
  if (params.isArchived === true) qs.set('isArchived', 'true');
  if (params.sort) {
    const [field, dir] = params.sort.split(':');
    if (field) qs.set('sort', field);
    if (dir) qs.set('order', dir.toLowerCase());
  }
  return qs.toString();
}

export function styleOrderDocumentsQueryOptions(
  styleId: string,
  params: StyleOrderDocumentsListParams,
) {
  return queryOptions({
    queryKey: ['my-styles', 'style-order-documents', styleId, params] as const,
    queryFn: () =>
      fetchStyleOrderDocuments(styleId, buildStyleOrderDocumentsQs(params)),
    enabled: !!styleId,
    staleTime: 60_000,
  });
}

export function useStyleOrderDocumentsQuery(
  styleId: string,
  params: StyleOrderDocumentsListParams,
) {
  return useQuery(styleOrderDocumentsQueryOptions(styleId, params));
}
